module.exports = __webpack_public_path__ + "img/redtick.a50d03c6.png";